import { useState } from "react";
import { api, errMsg } from "../../lib/api";

export function OutboundIp() {
  const [r, setR] = useState(null);
  const [busy, setBusy] = useState(false);
  const check = async () => {
    setBusy(true);
    try { setR((await api.get("/admin/integrations/outbound-ip")).data); } catch (e) { setR({ error: errMsg(e) }); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-1 border-t pt-4 text-sm" data-testid="outbound-ip">
      <button type="button" className="btn-outline" disabled={busy} onClick={check} data-testid="outbound-ip-btn">{busy ? "Checking…" : "Show server outbound IP"}</button>
      {r && (r.error ? <p className="text-red-700" data-testid="outbound-ip-error">{r.error}</p> : (
        <p data-testid="outbound-ip-result">Outbound IP: <b>{r.ip || "inconclusive"}</b> <span className="text-xs text-slate-600">
          ({Object.entries(r.sources).map(([k, v]) => `${k}: ${v}`).join(" · ")}; {r.checked_at.slice(0, 16).replace("T", " ")} UTC). Register it with the card payment gateway. {r.note}</span></p>))}
    </div>
  );
}
